
/*
* 版本管理
*/

<template>
  <div class="hbn-container" id="userInfo">
    <div class="search-form">
      <el-row :gutter="24">
        <el-col :span="18">
          <el-form
            ref="form"
            :model="form"
            label-width="80px"
            label-position="top"
            size="mini"
          >
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="版本信息">
                  <el-input
                    id="queryModelName"
                    v-model="PageQuery.queryModel.versionName"
                    placeholder="版本信息"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="系统">
                  <el-select
                    v-model="PageQuery.queryModel.appSystem"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in appSystemList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态">
                  <el-select
                    v-model="PageQuery.queryModel.status"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in statusList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="6">
          <el-form-item style="padding-top: 28px">
            <el-button size="mini" class="hbn-button-serach" @click="seach"
              >查找</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
    </div>

    <div class="hbn-table-screen">
      <div class="operation">
        <el-button
          class="custom-button"
          type="primary"
          :icon="Search"
          @click="add"
        >
          <i class="el-icon-circle-plus-outline custom-icon"></i>
          <span>新增</span>
        </el-button>
      </div>

      <div class="custom-table-layer">
        <div style="margin-bottom: 13px">
          <vxe-table
            :data="DataList"
            round
            border
            height="388"
            class="mytable-scrollbar"
            style="width: 100%"
            :highlight-current-row="true"
            @current-change="handleCurrentChange"
            @checkbox-change="handleSelectionChange"
            ref="multipleTable"
            highlight-hover-row
            highlight-hover-column
            highlight-current-column
            show-overflow="tooltip"
            empty-text="没有更多数据了！"
            resizable
            stripe
          >
            <vxe-table-column
              fixed="left"
              type="seq"
              width="55"
              title="序号"
              align="center"
            ></vxe-table-column>

            <template v-for="(item, key) in versionShowList" :key="key">
              <vxe-table-column
                :field="item.prop"
                :title="item.label"
                :width="item.width"
                align="center"
                v-if="item.isShow && item.prop != 'url'"
                show-overflow-tooltip
                :sortable="item.order"
                :class-name="JSON.stringify(item)"
                :formatter="formatterData"
              />
              <vxe-table-column
                :field="item.prop"
                :title="item.label"
                :width="item.width"
                align="center"
                v-else-if="item.isShow && item.prop == 'url'"
                show-overflow-tooltip
                :sortable="item.order"
                :class-name="JSON.stringify(item)"
              >
                <template #default="{ row }">
                  <img
                    width="100"
                    height="50"
                    :src="row.resourceRul"
                    title=""
                  />
                </template>
              </vxe-table-column>
            </template>

            <vxe-table-column
              width="180"
              fixed="right"
              title="操作"
              align="center"
            >
              <template #default="{ row, rowIndex }">
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(rowIndex, 'Detail')"
                  >查看</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  v-if="row.status != 1"
                  @click="handleClick(rowIndex, 'Modify')"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  v-if="row.status != 1"
                  @click="handleClick(rowIndex, 'Delete')"
                  >删除</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  v-if="row.status != 1"
                  @click="handleClick(rowIndex, 'Audit')"
                  >审核</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  v-if="row.status == 1"
                  @click="handleClick(rowIndex, 'Terminal')"
                  >终止</el-button
                >
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>

        <div class="pagination">
          <vxe-pager
            perfect
            size="mini"
            :current-page="PageQuery.pageindex"
            :page-size="PageQuery.PageSize"
            :page-sizes="[20, 50, 100, 500]"
            :total="total"
            :pager-count="5"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'NextJump',
              'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange"
          >
          </vxe-pager>
        </div>
      </div>
    </div>
    <AppVersionManagementEdit
      ref="appVersionManagementEdit"
      v-model:dialogVisible="dialogVisible"
      @close-dialog="closeDialog"
      @handle-cancel="handleCancel"
      @handle-confirm="handleConfirm"
    ></AppVersionManagementEdit>
  </div>
</template>

<script>
import { Search } from "@element-plus/icons";
import { versionShowList } from "@/assets/apiData/AppVersionManagementList";
import {
  GetDataAppVersionManagementList,
  DeleteAppVersionManagement,
  auditAppVersionManagement,
  terminalAppVersionManagement,
} from "@api/ApiAppVersionManagement";
import AppVersionManagementEdit from "@comp/SysInfo/AppVersionManagementEdit.vue";
import { dateFormat } from "@/util/utils.js";
import { ossPreview } from "@/util/ossClient.js";
import { ElMessageBox } from "element-plus";

export default {
  data() {
    return {
      PageQuery: {
        queryModel: {
          versionName: "",
          appSystem: "",
          status: -1,
          sortField: {
            CreationTime: "desc",
          },
        },
        pageindex: 1,
        PageSize: 20,
      },
      dialogVisible: false,
      total: 0,
      multipleSelection: [],
      versionShowList: [],
      entityData: {},
      appSystemList: [
        { value: "", label: "全部" },
        { value: "IOS", label: "IOS" },
        { value: "Android", label: "安卓" },
      ],
      statusList: [
        { value: -1, label: "全部" },
        { value: 0, label: "已创建" },
        { value: 1, label: "已审核" },
        { value: 2, label: "已终止" },
      ],
    };
  },
  components: {
    Search,
    AppVersionManagementEdit,
  },
  computed: {
    checkendSum() {
      return this.multipleSelection.length;
    },
  },
  methods: {
    error() {},
    success() {},
    handleClick(index, type) {
      this.AppVersionManagementEdit(index, type);
    },
    formatterData: function ({ cellValue, row, column }) {
      let head = JSON.parse(column.className);
      let format = head.format;
      switch (format) {
        case "datetime":
          cellValue = dateFormat("YYYY-mm-dd HH:MM:SS", cellValue);
          break;
        case "appSystem":
          cellValue = cellValue == "IOS" ? "IOS" : "安卓";
          break;
        case "updateStatus":
          cellValue = cellValue == "2" ? "是" : "否";
          break;
        case "status":
          switch (cellValue) {
            case 0:
              cellValue = "已创建";
              break;
            case 1:
              cellValue = "已审核";
              break;
            case 2:
              cellValue = "已终止";
              break;
          }
          break;
        case "downloadUrl":
          if (cellValue) cellValue = ossPreview(cellValue, "5");
          break;
      }
      return cellValue;
    },
    AppVersionManagementEdit(index, type) {
      var _this = this;
      let entityData = this.DataList[index];
      switch (type) {
        case "Delete":
          ElMessageBox.confirm(
            `您确认删除该版本吗？删除后数据将不可恢复`,
            "提示",
            {
              cancelButtonClass: "cancelstyle",
              confirmButtonClass: "confirmstyle",
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              closeOnClickModal: false,
            }
          ).then(() => {
            DeleteAppVersionManagement(entityData.id).then(function (data) {
              if (data) {
                _this.$message.success("删除成功");
                _this.PageQuery.pageindex = 1;
                _this.GetData();
              }
            });
          });
          break;
        case "Audit":
          ElMessageBox.confirm(`您确认审核该版本吗？`, "提示", {
            cancelButtonClass: "cancelstyle",
            confirmButtonClass: "confirmstyle",
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false,
          }).then(() => {
            auditAppVersionManagement(entityData).then(function (data) {
              if (data) {
                _this.$message.success("审核成功");
                _this.PageQuery.pageindex = 1;
                _this.GetData();
              }
            });
          });
          break;
        case "Terminal":
          ElMessageBox.confirm(`您确认终止该版本吗？`, "提示", {
            cancelButtonClass: "cancelstyle",
            confirmButtonClass: "confirmstyle",
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false,
          }).then(() => {
            terminalAppVersionManagement(entityData).then(function (data) {
              if (data) {
                _this.$message.success("终止成功");
                _this.PageQuery.pageindex = 1;
                _this.GetData();
              }
            });
          });
          break;
        default:
          this.dialogVisible = true;
          var id = 0;
          if (type != "Add") id = _this.DataList[index].id;
          this.$refs.appVersionManagementEdit.loadDataById(id, type);
          break;
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    //选中事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    add() {
      this.AppVersionManagementEdit(-1, "Add");
    },
    seach() {
      this.PageQuery.pageindex = 1;
      this.GetData();
    },

    handleSizeChange(val) {
      //分页
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.pageindex = 1; //说明更改了每页展示条数，要从第一页进行展示
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.pageindex = currentPage;
      }
      this.GetData();
    },
    handleCurrentChange(val) {
      console.log(val);
      this.GetData();
    },
    SearchDataInfo() {},
    GetData() {
      const _this = this;
      this.SearchDataInfo();
      try {
        GetDataAppVersionManagementList(JSON.stringify(this.PageQuery)).then(
          (result) => {
            _this.DataList = result.entities;
            _this.total = result.totalCount;
            _this.$refs.multipleTable.loadData(result.entities);
          }
        );
      } catch (e) {
        console.log(e);
      }
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    handleConfirm(val) {
      this.dialogVisible = false;
      this.PageQuery.pageindex = 1;
      this.GetData();
    },
    GetLoading(text) {
      return this.$loading({
        lock: true,
        text: text,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
  },
  created() {
    this.versionShowList = versionShowList;
    this.GetData();
  },
};
</script>
<style lang="scss">
@import "@/common/css/Hbn_modules/reset-input";
.custom-table-header > th {
  background: #dfdfdf !important;
}

.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
  color: #32383d;
}
.el-table .cell {
  color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}
.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
  border: 1px solid #acb5bd;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
}
</style>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";
#userInfo {
}
</style>
<style scoped>
.priorityNum {
  text-align: left;
  margin: 10px;
}
.pictureWarn {
  margin-left: 10px;
  color: red;
}
</style>
